import React, {useEffect, useState} from 'react';
import EpiContext from '@episerver/spa-core/Spa';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import Config from '../../../Config';
import icon120Error from './Images/icon-120-error.svg';
const FamilyMemberCellularSaleError = (props) => {
  async function buttonFunction() {
    let content = await EpiContext.loadContentByPath(Config.lobbyUrl);
    EpiContext.navigateTo(content);
  }
  return (
    <>
      <div className='FamilyMemberCellularSaleError'>
        <div className='image' style={{backgroundImage:icon120Error.bg()}}></div>
        <div className='title'>{props.title}</div>
        {props.subtitle && <div className='subtitle'>{props.subtitle}</div>}
        <BtnSubmit formid='failure-screen' onclick={() => buttonFunction()} text='חזרה לאיזור האישי'></BtnSubmit>
      </div>
    </>
  );
};

export default FamilyMemberCellularSaleError;
